"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMobilePreview = exports.getDesktopPreview = void 0;

var getDesktopPreview = function getDesktopPreview(state) {
  return state.preview.desktop;
};

exports.getDesktopPreview = getDesktopPreview;

var getMobilePreview = function getMobilePreview(state) {
  return state.preview.mobile;
};

exports.getMobilePreview = getMobilePreview;


//////////////////
// WEBPACK FOOTER
// ./js/selectors/Preview.js
// module id = 156
// module chunks = 0